import { ResidentialBannerType } from "@/enums/ResidentialBannerType"
import { CouponType } from "@reef-os/utils/enums/couponType"

let residentialBannerMixin = {
    computed: {
        isUserLoggedIn() {
            return this.$store.state.user && this.$store.state.user.id != 0
        },
        bannerType() {
            if (this.$store.getters.isResidential) {
                if (!this.isUserLoggedIn) {
                    return ResidentialBannerType.ACTIVATION
                }
                if (this.firstTimeCoupon) {
                    return ResidentialBannerType.FIRST_ORDER
                }
                if (this.loyaltyCampaign) {
                    const ordersNeeded =
                        this.loyaltyCampaign.progress.goal -
                        this.loyaltyCampaign.progress.count
                    if (ordersNeeded == 1) {
                        return ResidentialBannerType.LOYALTY
                    }
                    if (ordersNeeded == 0) {
                        return ResidentialBannerType.LOYALTY_COMPLETE
                    }
                }
                if (this.$store.state.user.smsOptIn == 0) {
                    return ResidentialBannerType.SMS_OPT_IN
                }
            }
            return null
        },
        firstTimeCoupon() {
            return this.$store.state.user.coupons.find(
                (coupon) => coupon.coupon_type == CouponType.FIRST_TIME
            )
        },
        loyaltyCampaign() {
            return this.$store.state.user.campaigns.find(
                campaign => campaign.campaign.type == 4
            )
        }
    }
}

export default residentialBannerMixin